const categoryDropdownBtnEl = document.querySelector('.category-btn');
let categoryId;

// Get category from URL query parameters
const urlParams = new URLSearchParams(window.location.search);
const categoryFromQuery = urlParams.get('category');

// Toggle dropdown content on dropdown button click
categoryDropdownBtnEl?.addEventListener('click', () => {
  categoryDropdownBtnEl.classList.toggle('dropdown__btn_active');
  const dropdownContent = categoryDropdownBtnEl.nextElementSibling;
  dropdownContent.classList.toggle('dropdown-content_active');

  const searchInputEl = document.querySelector('.search__input');
  if (categoryDropdownBtnEl.classList.contains('dropdown__btn_active')) {
    searchInputEl.classList.add('search__input_focused');
  } else {
    searchInputEl.classList.remove('search__input_focused');
  }
});

// HANDLE CATEGORIES START //
if (categoryDropdownBtnEl) {
  const categoryDropdownContent = categoryDropdownBtnEl.nextElementSibling;
  let prevSelectedCategoryEl = null;

  // Set initial category from query if it exists
  if (categoryFromQuery) {
    const categoryItems = categoryDropdownContent.querySelectorAll('.dropdown__item');
    categoryItems.forEach(item => {
      if (item.dataset.value === categoryFromQuery) {
        item.classList.add('dropdown__item_selected');
        categoryId = categoryFromQuery;
        prevSelectedCategoryEl = item;

        const inputEl = document.querySelector('input[name="category"][type="hidden"]');
        if (inputEl) {
          inputEl.value = categoryId;
        }
      }
    });
  }

  categoryDropdownContent.addEventListener('click', (e) => {
    if (e.target.classList.contains('dropdown__item')) {
      const optionItemEl = e.target;

      // If clicking the same category that's already selected, remove selection
      if (prevSelectedCategoryEl === optionItemEl) {
        optionItemEl.classList.remove('dropdown__item_selected');
        categoryId = '';
        prevSelectedCategoryEl = null;

        const inputEl = document.querySelector('input[name="category"][type="hidden"]');
        inputEl.value = '';
        return;
      }

      // remove selected class from previous selected category
      prevSelectedCategoryEl && prevSelectedCategoryEl.classList.remove('dropdown__item_selected');

      optionItemEl.classList.toggle('dropdown__item_selected');
      categoryId = optionItemEl.dataset.value;

      prevSelectedCategoryEl = optionItemEl;
      categoryDropdownBtnEl.classList.remove('dropdown__btn_active');
      categoryDropdownContent.classList.remove('dropdown-content_active');
      
      const searchInputEl = document.querySelector('.search__input');
      searchInputEl.classList.remove('search__input_focused');

      const inputEl = document.querySelector('input[name="category"][type="hidden"]');
      inputEl.value = categoryId;
    }
  });
}
// HANDLE CATEGORIES END //